/**
 * TabSection — renders section title and fields in a 12-column grid.
 *
 * @module components/form/TabSection
 * @see FMPV-MVWC-E003-S001 I-007
 */
import React, { type ReactNode } from 'react';

export interface TabSectionProps {
  sectionKey: string;
  label?: string;
  children: ReactNode;
}

export function TabSection({ sectionKey, label, children }: TabSectionProps) {
  return (
    <div data-testid={`tab-section-${sectionKey}`} className="mb-6">
      {label && (
        <div className="flex items-center gap-2.5 pt-4 pb-2 px-0 mb-0">
          <h3 className="text-xs font-bold text-[#a1a1aa] uppercase tracking-[0.4px] whitespace-nowrap">
            {label}
          </h3>
          <div className="flex-1 h-px bg-[#f4f4f5]" />
        </div>
      )}
      <div className="grid grid-cols-12 gap-x-4 gap-y-5 px-5 pt-4">
        {children}
      </div>
    </div>
  );
}
